import z from "zod";
import { FILE_COLLECTION_TABLES } from "../../../types/files";

/**
 * Filing one inbox file by hand: which collection it goes into, and which parent within it.
 *
 * The same pair `POST /files/:tableName` takes, with the collection moved out of the path and into
 * the body — the path here names the *file*, because that is what the caller is acting on. Which
 * columns `foreignKeyValues` names is the registry's check, exactly as it is there.
 */
export const postFileInboxJsonSchema = z.object({
	tableName: z.enum(FILE_COLLECTION_TABLES),
	foreignKeyValues: z
		.record(z.string(), z.uuid())
		.refine((values) => Object.keys(values).length > 0, {
			message: "foreignKeyValues must name at least one parent column",
		}),
});

export type PostFileInboxJsonSchema = z.infer<typeof postFileInboxJsonSchema>;
